import React from "react";
import { MainLayout } from "../../layouts";
import { ResponsiveContainer } from "../../components";
import { Breadcrumb } from "antd";

const Home = () => {
  return (
    <MainLayout fixed={true} className="bg-or_gray-100">
      <ResponsiveContainer>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>List</Breadcrumb.Item>
          <Breadcrumb.Item>App</Breadcrumb.Item>
        </Breadcrumb>
      </ResponsiveContainer>
    </MainLayout>
  );
};

export default Home;
